//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: ['resident'],
    data: function data() {
        return {
            person: {},
            property: '',
            money: {
                decimal: '.',
                thousands: ',',
                prefix: '$',
                suffix: '',
                precision: 2,
                masked: false
            },
            lease_start_date: '',
            lease_expiration_date: ''
        };
    },
    created: function created() {
        Event.$on('resident-renew-lease', this.residentRenewLease);
    },
    beforeDestroy: function beforeDestroy() {
        Event.$off('resident-renew-lease');
    },

    methods: {
        residentRenewLease: function residentRenewLease(resident) {
            console.log('residentRenewLease() method fired, resetting date values...');
            var $el = this;
            $el.person = resident;
            $el.property = resident.property.name;
            if ($el.person.lease) {
                // set renewal start date to active lease_expiration_date + 1 day
                var renewalStart = moment($el.person.lease.lease_expiration_date).add(1, 'days');
                this.lease_start_date = renewalStart.format("MM/DD/YYYY");
                this.lease_expiration_date = renewalStart.add(-1, 'days').add(1, 'years').format("MM/DD/YYYY");
            }
            $el.person.renewal_rent_amount = $el.resident.lease.actual_rent_amount;
            $el.$children[0].$data.showSmallModal = true;
        },

        saveLease: function saveLease() {
            var _this = this;

            var $el = this;

            this.person.id = $el.resident.id;
            this.person.renewal_move_in_date = this.lease_start_date;
            this.person.renewal_lease_expire_date = this.lease_expiration_date;
            axios.post('/prototype/person/resident/renewal-lease', this.person).then(function (response) {
                if (response.data.error) {
                    _this.$snotify.error('Validation Error: ' + response.data.error);
                } else {
                    _this.$snotify.success('Renewal lease added');
                    Event.$emit('reload-resident');
                    Event.$emit('close-small-modal');
                    Event.$emit('resident-list-dashboard-updated');
                    Event.$emit('refresh-resident-dashboard');
                }
            });
        },
        leaseStartDateChanged: function leaseStartDateChanged() {
            var $el = this;
            $el.lease_expiration_date = $el.lease_expiration_date ? moment(this.lease_start_date).subtract(1, 'days').add(1, 'years').format("MM/DD/YYYY") : '';
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/person/residents/ResidentRenewLease.vue
// module id = n6qO
// module chunks = 0 1